export default __webpack_public_path__ + "static/groups-ideas-family-1-b3ef1f15de8d9b9699f4a68486975733.jpg";